import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { CheckoutDeliveryAddressFacade, CheckoutDeliveryModesFacade } from '@spartacus/checkout/base/root';
import { GlobalMessageService, TranslationService, UserAddressService } from '@spartacus/core';
import { OrgUnitService } from '@spartacus/organization/administration/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { UserProfileFacade } from '@spartacus/user/profile/root';

@Component({
  selector: 'app-checkout-address',
  standalone: false,
  templateUrl: './checkout-address.component.html',
  styleUrls: ['./checkout-address.component.scss'],
})
export class CheckoutAddressComponent {
  ngOnInit() {
    this.userAddressService.getAddresses().subscribe((a) => {
    });

    this.userService.get().subscribe((a) => {
    });

    this.checkoutDeliveryAddressFacade.getDeliveryAddressState().subscribe((a) => {
    });

    this.userFacade.get().subscribe((a: any) => {
    });
  }

  constructor(
    protected userAddressService: UserAddressService,
    protected checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    protected activatedRoute: ActivatedRoute,
    protected translationService: TranslationService,
    protected activeCartFacade: ActiveCartFacade,
    protected checkoutStepService: CheckoutStepService,
    protected checkoutDeliveryModesFacade: CheckoutDeliveryModesFacade,
    protected globalMessageService: GlobalMessageService,
    protected userService: UserProfileFacade,
    protected userFacade: UserAccountFacade,
    protected orgUnitService: OrgUnitService
  ) {}
}
